import { combineReducers } from 'redux';

import userReducer from './user/reducer';
import regionReducer from './region/reducer';
import siteReducer from './site/reducer';
import userRolesReducer from './userRoles/reducer';
import reportReducer from './report/reducer';
import districtReducer from './district/reducer';
import chiefdomReducer from './chiefdom/reducer';
import divisionReducer from './division/reducer';
import branchReducer from './branch/reducer';

const appReducer = combineReducers({
  user: userReducer,
  region: regionReducer,
  site: siteReducer,
  userRoles: userRolesReducer,
  report: reportReducer,
  district: districtReducer,
  chiefdom: chiefdomReducer,
  division: divisionReducer,
  branch: branchReducer
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET_STORE') {
    state = undefined;
  }
  return appReducer(state, action);
};
export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;
